export enum GoogleButtonEvents {
  clickSignInWithGoogle = 'click_sign_in_with_google',
  eventRegistration = 'event_registration',
}
